module.exports = __webpack_public_path__ + "img/Miglino.2a2feff5.jpg";